/** IMPORTANT: Routes should use hyphens */
export const appRoutes = {
  homePage: '/',
  videoPage: '/video/:videoId',
  channel: '/channel/:channelId/:channelSlug/:pageNumber?/:videoId?',
  mobileComments: '/comments/:videoId?',
  mobileAttachments: '/attachments/:videoId?',
  upload: '/upload',
  uploadPodcast: '/upload-podcast',
  error500: '/error-500',
  error404: '/error-404',
  permissionError: '/permission-error',
  search: '/search/:searchTerm/:pageNumber?/:videoId?',
  myVideosEdit: '/my-videos/edit/:videoId',
  myVideos: '/my-videos/:pageNumber?/:videoId?/:sort?',
  administration: '/administration',
  channelAccess: '/channel-access',
  startChannel: '/start-channel',
  savedVideos: '/saved-videos/:pageNumber/:videoId?/:sort?',
  uitRegularDownload: '/film-herunterladen/:videoId',
  uitArchiveDownload: '/download/:videoId',
};
